<template>
    <nav class="border-t border-gray-200 px-4 " aria-label="Pagination">
        <div class="container flex items-center justify-between sm:px-0">
            <template v-for="(link, key) in links">
                <div
                    v-if="key === 0 || key === links.length - 1"
                    class="-mt-px w-0 flex-1 flex"
                    :class="{ 'justify-end': key === links.length - 1 }"
                >
                    <div
                        v-if="link.url === null"
                        :key="key"
                        class="border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-400"
                        v-html="link.label"
                    />
                    <Link
                        v-else
                        :key="`link-${key}`"
                        class="border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        :href="link.url"
                        :only="['products']"
                        v-html="link.label"
                    />
                </div>

                <div
                    v-else
                    class="hidden md:-mt-px md:flex"
                >
                    <div
                        v-if="link.active"
                        :key="key"
                        class="border-indigo-500 text-indigo-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium"
                        aria-current="page"
                        v-html="link.label"/>
                    <Link
                        v-else
                        :key="`link-${key}`"
                        class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium"
                        :href="link.url"
                        :only="['products']"
                        v-html="link.label"
                    />
                </div>

            </template>
        </div>
    </nav>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Link
    },

    props: {
        links: {
            type: Array,
            required: true
        },
    },
}
</script>
